export function isMarketDataStreamBrowserE2EMode(): boolean {
  const enabled = import.meta.env.VITE_MARKET_DATA_STREAM_BROWSER_E2E === "1";
  return enabled && (import.meta.env.DEV || import.meta.env.MODE === "test");
}
